export function getAbbreviation(name) {
	const words = name.split(' ', 2);

	if (words.length < 2) {
		return name.slice(0, 2).toUpperCase();
	}

	return words.reduce((acc, word) => acc + word[0].toUpperCase(), '');
}
